/* eslint-disable prefer-rest-params */
import * as log from 'loglevel';
import * as Sentry from '@sentry/browser';
import packageJson from '../../package.json';
import { env } from './config';

const environment = env.NODE_ENV;

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

if (!isLocal && environment.match(/(development|staging|production)/)) {
    Sentry.init({
        dsn: 'https://6d67de9679f143d087e7bbfb76e01852@sentry.io/90713',
        environment: env.NODE_ENV,
        release: packageJson.version,
        whitelistUrls: [/https:\/\/.*?\.planetos\.com/],
    });
    const originalFactory = log.methodFactory;
    log.methodFactory = function(methodName, logLevel, loggerName) {
        const rawMethod = originalFactory(methodName, logLevel, loggerName);
        return function() {
            if (methodName === 'error') {
                Sentry.captureException(...arguments);
            }
            return rawMethod(...arguments);
        };
    };
}

if (env.NODE_ENV === 'test') {
    log.disableAll();
}

log.setLevel(env.LOG_LEVEL || 'error');

export const Logger = log;
